import * as React from 'react';
import { Subtract } from 'utility-types';

import {ISanitizer} from '~commonInfra/utils/Sanitize';
export interface InjectedPredictiveModelSpaceServiceInjectorProps {
  readonly sanitizer: ISanitizer;
}

export interface PredictiveModelSpaceServiceInjectorProps {
  readonly predictiveModelId: string;
}

export function withPredictiveModelSpaceServiceInjector<P extends InjectedPredictiveModelSpaceServiceInjectorProps>(
  Component: React.ComponentType<P>
) {
  return function PredictiveModelSpaceServiceInjector(
    props: Subtract<P, InjectedPredictiveModelSpaceServiceInjectorProps> & PredictiveModelSpaceServiceInjectorProps
  ) {

    return <Component
      {...props as unknown as P}
    />;
  };
}
